/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import {Menu} from 'semantic-ui-react'
import './MainMenu.css'
import { logout } from './helpers/auth'

export default class MainMenu extends Component {
    state = {}

    handleItemClick = (e, {name}) => this.setState({activeItem: name})

    render() {
        const {activeItem} = this.state

        return (
            <div className="ui attached stackable menu">
                <div className="ui container">
                    <Menu.Item
                        name='cards'
                        active={activeItem === 'cards'}
                        onClick={this.handleItemClick}
                        href="/cards"
                    >
                        Cards
                    </Menu.Item>

                    <Menu.Item
                        name='card_edit'
                        active={activeItem === 'card_edit'}
                        onClick={this.handleItemClick}
                        href="/cards/edit"
                    >
                        Add Card
                    </Menu.Item>

                    <Menu.Item
                        name='places'
                        active={activeItem === 'places'}
                        onClick={this.handleItemClick}
                        href="/places"
                    >
                        Places
                    </Menu.Item>

                    <Menu.Item
                        name='place_add'
                        active={activeItem === 'place_add'}
                        onClick={this.handleItemClick}
                        href="/places/edit"
                    >
                        Add Place
                    </Menu.Item>

                    <Menu.Menu position='right'>
                        <Menu.Item name='logout' onClick={logout}/>
                    </Menu.Menu>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/MainMenu.js